// extracted by mini-css-extract-plugin
export default {"definition":"DefinitionSection_definition__louUx","example":"DefinitionSection_example__z1CC0","translate":"DefinitionSection_translate__G3I4t"};